import { useMemo } from 'react'
import { useBlacklistedVaultsQuery } from 'graphql/backend/vaults'
import type { BlacklistedVaultsQueryPayload } from 'graphql/backend/vaults'

import useConfig from './useConfig'


type Output = {
  blacklist: string[]
  isFetching: boolean
}

const modifyResult = (data: BlacklistedVaultsQueryPayload): Output['blacklist'] => (
  data.vaults.map((vault) => vault.address)
)

const useBlacklist = (isSSR?: boolean): Output => {
  const { sdk } = useConfig()

  const { data, isFetching } = useBlacklistedVaultsQuery({
    urls: sdk.config.api,
    pause: isSSR,
    modifyResult,
  })

  return useMemo(() => ({
    blacklist: data || [],
    isFetching,
  }), [ data, isFetching ])
}


export default useBlacklist
